import React from "react";

export enum VerboseSowPdfMode {
	WITH_LINE_ITEM_PRICES = "WITH_LINE_ITEM_PRICES",
	WITHOUT_LINE_ITEM_PRICES = "WITHOUT_LINE_ITEM_PRICES",
}

interface VerboseSowPdfModeFieldProps {
	value: VerboseSowPdfMode;
	onChange: (value: VerboseSowPdfMode) => void;
}

const VerboseSowPdfModeField: React.FC<VerboseSowPdfModeFieldProps> = ({ value, onChange }) => {
	return (
		<div className="p-4 bg-white rounded-lg border border-gray-200">
			<label className="block text-gray-900 text-base font-medium font-['Hanken Grotesk'] mb-2">
				Verbose Statement of Work PDF
			</label>
			<div className="text-gray-500 text-sm mb-2">
				Controls per-line-item prices in the verbose Statement of Work PDF. Room and category subtotals are always shown.
			</div>
			<select
				value={value}
				onChange={(e) => onChange(e.target.value as VerboseSowPdfMode)}
				className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
			>
				<option value={VerboseSowPdfMode.WITH_LINE_ITEM_PRICES}>Show line item prices</option>
				<option value={VerboseSowPdfMode.WITHOUT_LINE_ITEM_PRICES}>Hide line item prices</option>
			</select>
		</div>
	);
};

export default VerboseSowPdfModeField;
